import React from 'react'
import { uniqueId } from 'lodash'
import {
  Badge,
  BadgeProps,
  Button,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap'
import { OverlayInjectedProps } from 'react-bootstrap/Overlay'
import ConditionalWrap from 'conditional-wrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'

import { OfferType } from '@monorepo/interfaces'
import { useComponentVisible } from '@monorepo/hooks'

import { CalculationDetails } from './CalculationDetails'

type PriceCalculatorInfoProps = BadgeProps & {
  offer: OfferType
}

export const PriceCalculatorInfo: React.FC<PriceCalculatorInfoProps> = ({
  offer,
  ...props
}) => {
  const {
    isComponentVisible,
    showComponentHandler,
    hideComponentHandler,
  } = useComponentVisible(false)

  const renderTooltip = (props: OverlayInjectedProps) => (
    <Tooltip id={uniqueId('tooltip-')} {...props}>
      Расчет цены
    </Tooltip>
  )

  return (
    <>
      <ConditionalWrap
        condition={!isComponentVisible}
        wrap={(children: any) => (
          <OverlayTrigger overlay={renderTooltip}>{children}</OverlayTrigger>
        )}
      >
        <Badge {...props} onClick={showComponentHandler}>
          <FontAwesomeIcon icon={faQuestion} />
        </Badge>
      </ConditionalWrap>

      <Modal show={isComponentVisible} onHide={hideComponentHandler}>
        <Modal.Header closeButton>
          <Modal.Title>
            Расчёт цены {offer.good.name}
            <br />
            {offer.vendor.name && (
              <em>
                <strong>Поставщик:</strong> {offer.vendor.name}
              </em>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CalculationDetails offer={offer} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={hideComponentHandler}>
            Закрыть
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
